<template>
  <center-layout-form title="ログイン">
    <template slot="outer">
      <el-dialog
        class="message-box"
        title="有効期限が迫っています"
        :visible.sync="bulkAlertDialog.visible"
        :close-on-click-modal="false"
        width="70%"
        :show-close="false"
        :close-on-press-escape="false"
      >
        <el-alert
          class="alert-area"
          type="error"
          :closable="false"
          show-icon>
          <div class = "text" >
            {{ bulkAlertDialog.message}} <br>
            {{ this.$config.alert_msg }}
          </div>
        </el-alert>

        <span slot="footer" class="dialog-footer">
          <el-button @click="onAlertClose()" >OK</el-button>
        </span>
      </el-dialog>
    </template>

    <template slot="body">
      <el-form
        v-if="isSupportBrowser && step === 'credentials'"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="100px"
        autocomplete="off"
      >
        <el-form-item prop="username">
          <el-input
            size="large"
            v-model="form.username"
            :maxlength="1024"
            placeholder="ユーザ名"
            autofocus
          >
            <template slot="prepend">
              <i class="fa fa-user fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            size="large"
            type="password"
            v-model="form.password"
            :maxlength="1024"
            placeholder="パスワード"
            @keyup.enter.native="onSubmit('form')"
          >
            <template slot="prepend">
              <i class="fa fa-key fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item v-bind:class="{alert: isAlert}">
          <el-button
            size="large"
            class="login"
            type="primary"
            @click="onSubmit('form')"
            :loading="loading"
          >ログイン</el-button>
        </el-form-item>
        <el-alert v-if="isAlert" :title="errorMessage" type="error" show-icon :closable="false"></el-alert>
      </el-form>

      <el-form
        v-else-if="step === 'otp'"
        ref="otpForm"
        :model="otpForm"
        :rules="otpRules"
        label-position="top"
        @submit.native.prevent
      >
        <p class="mfa-description">認証アプリに表示されている6桁のコードを入力してください。</p>
        <el-form-item prop="code">
          <el-input
            size="large"
            v-model="otpForm.code"
            :maxlength="6"
            placeholder="認証コード"
            autofocus
            @keyup.enter.native="onSubmitOtp"
          >
            <template slot="prepend">
              <i class="fa fa-mobile fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item v-bind:class="{alert: isAlert}">
          <el-button
            size="large"
            class="login"
            type="primary"
            @click="onSubmitOtp"
            :loading="loading"
          >検証</el-button>
        </el-form-item>
        <el-button type="text" @click="backToCredentials()">ユーザ名の入力に戻る</el-button>
        <el-alert v-if="isAlert" :title="errorMessage" type="error" show-icon :closable="false"></el-alert>
      </el-form>

      <div v-else-if="step === 'setup'" class="mfa-setup">
        <p class="mfa-description">
          多要素認証の初回登録が必要です。認証アプリ(Google Authenticator、Microsoft Authenticator等)で
          QRコードを読み取り、表示された6桁のコードを入力してください。
        </p>
        <img :src="qrDataUrl" class="mfa-qr" />
        <p class="mfa-secret">手入力用キー: {{ mfaSecret }}</p>
        <el-form ref="otpForm" :model="otpForm" :rules="otpRules" label-position="top" @submit.native.prevent>
          <el-form-item prop="code">
            <el-input
              size="large"
              v-model="otpForm.code"
              :maxlength="6"
              placeholder="認証コード"
              @keyup.enter.native="onSubmitSetupConfirm"
            ></el-input>
          </el-form-item>
          <el-form-item v-bind:class="{alert: isAlert}">
            <el-button
              size="large"
              class="login"
              type="primary"
              @click="onSubmitSetupConfirm"
              :loading="loading"
            >登録してログイン</el-button>
          </el-form-item>
          <el-button type="text" @click="backToCredentials()">ユーザ名の入力に戻る</el-button>
          <el-alert v-if="isAlert" :title="errorMessage" type="error" show-icon :closable="false"></el-alert>
        </el-form>
      </div>
    </template>
  </center-layout-form>
</template>

<script>
import axios from "axios";
import QRCode from "qrcode";
import CenterLayoutForm from "@/components/CenterLayoutForm";

export default {
  components: {
    CenterLayoutForm
  },
  props: {
    isExtension: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    const endpointUrl = "/api/accounts/login/";
    return {
      endpointUrl,
      isAlert: false,
      loading: false,
      errorMessage: "",
      form: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "ユーザ名を入力してください",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "パスワードを入力してください",
            trigger: "blur"
          }
        ]
      },
      isSupportBrowse: false,
      bulkAlertDialog: {
        visible: false,
        message: "",
      },
      step: "credentials", // credentials | otp | setup
      otpForm: { code: "" },
      otpRules: {
        code: [
          { required: true, message: "認証コードを入力してください", trigger: "blur" }
        ]
      },
      mfaSecret: "",
      qrDataUrl: "",
    };
  },
  created() {
    this.initialize();
    this.isSupportBrowser = this.isChromeBrowser();
  },
  watch: {
    $route: "initialize"
  },
  methods: {
    initialize() {
      if (this.isExtension) {
        window.top.postMessage("loaded", "*");
      }
      axios.get(this.endpointUrl);
    },
    onSubmit(formName) {
      this.isAlert = false;
      this.loading = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios
            .post(this.endpointUrl, this.form)
            .then(response => {
              if (response.data.mfa_required) {
                if (response.data.mfa_setup_required) {
                  this.startMfaSetup();
                } else {
                  this.step = "otp";
                  this.loading = false;
                }
                return;
              }
              this.handleLoginSuccess(response);
            })
            .catch(error => {
              this.loading = false;
              if (error.response.status === 400) {
                if ("message" in error.response.data) {
                  console.log(error.response.data);
                  this.errorMessage = error.response.data.message;
                } else {
                  if (error.response.data.locked === true) {
                    this.errorMessage = "連続認証失敗によりロックされました";
                  } else {
                    this.errorMessage = "認証に失敗しました";
                  }
                }
                this.isAlert = true;
              } else if (error.response.status === 403) {
                this.errorMessage = error.response.data["detail"];
                this.isAlert = true;
              }
            });
        } else {
          return false;
        }
      });
    },
    handleLoginSuccess(response) {
      if (response.data.alert_flg) {
        this.bulkAlertDialog.visible = true;
        this.bulkAlertDialog.message = response.data.message;
        this.loading = false;
      } else if (response.data.reset) {
        this.$router.push({
          name: "changePassword",
          query: this.$route.query
        });
      } else if ("next" in this.$route.query) {
        console.log(this.$route.query.next);
        window.location.href = this.$route.query.next;
      } else {
        this.$router.push({ name: "top" });
      }
    },
    startMfaSetup() {
      axios
        .post("/api/accounts/mfa/setup/")
        .then(response => {
          this.mfaSecret = response.data.secret;
          return QRCode.toDataURL(response.data.otpauth_uri);
        })
        .then(url => {
          this.qrDataUrl = url;
          this.otpForm.code = "";
          this.step = "setup";
          this.loading = false;
        })
        .catch(() => {
          this.backToCredentials("時間切れです。もう一度ログインしてください");
        });
    },
    onSubmitOtp() {
      this.$refs.otpForm.validate(valid => {
        if (valid) {
          this.postCode("/api/accounts/mfa/verify/");
        }
      });
    },
    onSubmitSetupConfirm() {
      this.$refs.otpForm.validate(valid => {
        if (valid) {
          this.postCode("/api/accounts/mfa/setup/confirm/");
        }
      });
    },
    postCode(url) {
      this.isAlert = false;
      this.loading = true;
      axios
        .post(url, { code: this.otpForm.code })
        .then(response => {
          this.handleLoginSuccess(response);
        })
        .catch(error => {
          this.loading = false;
          const data = (error.response && error.response.data) || {};
          if (data.mfa_locked) {
            this.backToCredentials("連続して認証に失敗したため、一時的にロックしました。15分ほど待ってから再度ログインしてください");
          } else if (data.mfa_expired) {
            this.backToCredentials("時間切れです。もう一度ログインしてください");
          } else {
            this.errorMessage = "認証コードが正しくありません";
            this.isAlert = true;
          }
        });
    },
    backToCredentials(message) {
      this.step = "credentials";
      this.otpForm.code = "";
      this.form.password = "";
      this.loading = false;
      this.isAlert = false;
      if (message) {
        this.errorMessage = message;
        this.isAlert = true;
      }
    },
    isChromeBrowser() {
      let agent = window.navigator.userAgent.toLowerCase();
      if (agent.indexOf("edge") > -1) {
        return true;
      } else if (agent.indexOf("chrome") > -1) {
        return true;
      } else if (agent.indexOf("firefox") > -1) {
        return true;
      } else if (agent.indexOf("iphone") > -1) {
        return true;
      }
      return false;
    },
    onAlertClose(){
      if ("next" in this.$route.query) {
        console.log(this.$route.query.next);
        window.location.href = this.$route.query.next;
      } else {
        this.$router.push({ name: "top" });
      }
    }
  }
};
</script>

<style scoped>
.login {
  width: 100%;
}

.login-block {
  background-color: #fff;
  border: 1px solid #eaeefb;
  border-radius: 6px;
  padding: 32px 16px 8px 16px;
}

.el-form-item {
  padding-bottom: 4px;
}

.el-form-item.alert {
  margin-bottom: 4px !important;
}

.alert-area {
  width: 100%;
  height: 200px;
  margin: auto;
}

.alert-area >>> .el-alert__title {
  font-size: 20px;
}

.text {
  font-size: 20px;
}

.mfa-description {
  font-size: 14px;
  margin-bottom: 12px;
}

.mfa-qr {
  display: block;
  margin: 0 auto 8px;
  width: 180px;
}

.mfa-secret {
  font-size: 12px;
  text-align: center;
  word-break: break-all;
  color: #666;
  margin-bottom: 12px;
}
</style>
